import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useEffect, useLayoutEffect, useRef, useCallback } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { withRouter } from "../../Helpers/withRouter";
import { FormattedMessage as Translation } from 'react-intl';
import classnames from 'classnames';
import { Icon, Button } from '@olxin/panamera-react-ui';
import { getBundles as _getBundles } from "../../Store/Actions/bundles";
import CookieManager from "../../Utils/CookieManager";
import { bundlesSelector, isError, isFetching } from "../../Store/Selectors/bundles";
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import DependencyManager from "../../DependencyManager";
import SliderArrow from "./SliderArrow/SliderArrow";
var css = {
  "cardContainer": "oalp-3VMKF",
  "tagImage": "oalp-PtTu_",
  "tagImgContainer": "oalp-1FdWe",
  "withArrows": "oalp-H67B9",
  "showAllCard": "oalp-36ufY",
  "viewAllCarouselItem": "oalp-3UYID",
  "withoutVasStrip": "oalp-20QWB",
  "searchIcon": "oalp-1PwLr",
  "viewAllBtn": "oalp-3W8DO",
  "loaderContainer": "oalp-1gZRo",
  "buyEngager": "oalp-k92h0",
  "desktop": "oalp-1UdNd",
  "bundleCard": "oalp-Ny4TC",
  "zrpWidget": "oalp-3WrXh",
  "mobile": "oalp-wvPj3",
  "autoHeight": "oalp-1bDGj",
  "expandTrack": "oalp-3PP3S",
  "showAllLink": "oalp-2m0Ff",
  "bundleEmptyContainer": "oalp-2Wikh",
  "empty": "oalp-1t7PG",
  "overlay": "oalp-1joMO"
};
import ShimmerCarouselCard from "../ShimmerCarouselCard/ShimmerCarouselCard";
import { EMPTY_BUNDLE, mobileBreakPoints } from "../../Constants/bundle";
import classNames from 'classnames';
import withConfig from "../../ComponentDependency/withConfig";
import { UNKNOWN } from "../../Constants/locations";
import { getTrackingOrigin } from "../../Store/Selectors/layout";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { HP_OLX_TRACKING } from "../../Constants/hptracking";
import { getLocationUrl } from "../../Helpers/bundle";
import ImageWrapper from "../ImageWrapper/ImageWrapper";
var THRESHOLD_TOTAL = 6;
var AVG_INTERSECTION_RATIO = 0.47;
var INTIAL_THRESHOLD = 0;
var THRESHOLD_DIFF = 0.1;
var THRESHOLDS = _toConsumableArray(new Array(THRESHOLD_TOTAL)).map(function (_, i) {
  return INTIAL_THRESHOLD + THRESHOLD_DIFF * i;
});
var LOGO_LEFT_INITIAL = 44;
var LOGO_LEFT_THRESHOLD = 16;
export var Bundle = function Bundle(_ref) {
  var bundles = _ref.bundles,
    ItemCard = _ref.ItemCard,
    getBundles = _ref.getBundles,
    reqProps = _ref.reqProps,
    count = _ref.count,
    showAllUrl = _ref.showAllUrl,
    _ref$sliderSettings = _ref.sliderSettings,
    sliderSettings = _ref$sliderSettings === void 0 ? {} : _ref$sliderSettings,
    selectedTab = _ref.selectedTab,
    source = _ref.source,
    EmptyCenter = _ref.EmptyCenter,
    isError = _ref.isError,
    isFetching = _ref.isFetching,
    _ref$hideViewAllCard = _ref.hideViewAllCard,
    hideViewAllCard = _ref$hideViewAllCard === void 0 ? false : _ref$hideViewAllCard,
    _ref$hideShowAllLink = _ref.hideShowAllLink,
    hideShowAllLink = _ref$hideShowAllLink === void 0 ? false : _ref$hideShowAllLink,
    track = _ref.track,
    widgetKey = _ref.widgetKey,
    locationId = _ref.locationId,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin,
    metadata = _ref.metadata,
    location = _ref.location,
    router = _ref.router,
    VasSheetAsync = _ref.VasSheetAsync,
    templateName = _ref.templateName,
    name = _ref.name,
    onItemView = _ref.onItemView,
    _ref$showOriginalTitl = _ref.showOriginalTitle,
    showOriginalTitle = _ref$showOriginalTitl === void 0 ? false : _ref$showOriginalTitl,
    _ref$showSubTitle = _ref.showSubTitle,
    showSubTitle = _ref$showSubTitle === void 0 ? false : _ref$showSubTitle,
    _ref$showSubDetails = _ref.showSubDetails,
    showSubDetails = _ref$showSubDetails === void 0 ? false : _ref$showSubDetails,
    showTagInFirstCard = _ref.showTagInFirstCard,
    tagImage = _ref.tagImage,
    ReactObserver = _ref.ReactObserver,
    setHasData = _ref.setHasData,
    visualizationType = _ref.visualizationType,
    showYearInVasSheet = _ref.showYearInVasSheet,
    _ref$showFullPrice = _ref.showFullPrice,
    showFullPrice = _ref$showFullPrice === void 0 ? false : _ref$showFullPrice,
    _ref$showOlxAutosAdCa = _ref.showOlxAutosAdCardTag,
    showOlxAutosAdCardTag = _ref$showOlxAutosAdCa === void 0 ? true : _ref$showOlxAutosAdCa,
    selectFrom = _ref.selectFrom,
    showMakeModel = _ref.showMakeModel,
    _ref$showEmiPlaceHold = _ref.showEmiPlaceHolder,
    showEmiPlaceHolder = _ref$showEmiPlaceHold === void 0 ? true : _ref$showEmiPlaceHold,
    _ref$showVasStrip = _ref.showVasStrip,
    showVasStrip = _ref$showVasStrip === void 0 ? true : _ref$showVasStrip,
    emptyCentreImageName = _ref.emptyCentreImageName,
    responsiveBreakpoints = _ref.responsiveBreakpoints,
    zrpWidget = _ref.zrpWidget,
    widgetType = _ref.widgetType;
  var _a, _b;
  var bundleSize = Object.keys(bundles).length;
  var slider = useRef(null);
  var firstCardRef = useRef(null);
  var tagImageRef = useRef(null);
  var cardContainerRef = useRef(null);
  var vasHash = "#".concat(widgetKey);
  useLayoutEffect(function () {
    if (slider && slider.current) {
      slider.current.slickGoTo(0);
    }
  }, [selectedTab]);
  useEffect(function () {
    if (isError) {
      setHasData === null || setHasData === void 0 ? void 0 : setHasData(false);
    }
  }, [isError, setHasData]);
  var handleAnimation = useCallback(function () {
    var img = document.querySelector("#".concat(tagImage === null || tagImage === void 0 ? void 0 : tagImage.alt));
    if (tagImageRef.current) {
      for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
      }
      var intersectionRatio = props[1].intersectionRatio > AVG_INTERSECTION_RATIO ? 1 : props[1].intersectionRatio;
      tagImageRef.current.style.opacity = intersectionRatio;
      if (img) {
        var left = intersectionRatio * LOGO_LEFT_INITIAL < LOGO_LEFT_THRESHOLD ? LOGO_LEFT_THRESHOLD : intersectionRatio * LOGO_LEFT_INITIAL;
        img.style.left = "".concat(left, "px");
      }
    }
  }, [tagImage === null || tagImage === void 0 ? void 0 : tagImage.alt]);
  var clickHandler = useCallback(function () {
    if (track && metadata && metadata.trackingInfo && metadata.trackingInfo.clickEvent && metadata.trackingInfo.clickEvent.name) {
      var trackingName = metadata.trackingInfo.clickEvent.name;
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        variants_shown: widgetKey,
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin,
        chosen_option: '',
        reason: 'show_everything',
        resultset_type: metadata === null || metadata === void 0 ? void 0 : metadata.resultsetType
      });
      if (templateName === 'BuyEngagerWidget' && name) {
        trackingInfo['chosen_option'] = name;
        trackingInfo['resultset_type'] = templateName;
        trackingName = metadata.trackingInfo.clickEventSeeMore.name;
      }
      track(trackingName, trackingInfo);
    }
    if (showAllUrl) {
      var stateObj;
      if (zrpWidget) {
        stateObj = {
          state: {
            select_from: "rf_".concat(widgetType)
          }
        };
      }
      router === null || router === void 0 ? void 0 : router.push(showAllUrl, stateObj);
    }
  }, [browsingMode, locationId, origin, router, showAllUrl, track, widgetKey, metadata, name, templateName]);
  var isViewAllCardVisible = !hideViewAllCard && showAllUrl && bundles && !!bundleSize && bundleSize > count;
  var breakpointsMobile = responsiveBreakpoints || mobileBreakPoints;
  var commonSetting = {
    dots: false,
    lazyLoad: 'ondemand',
    infinite: false,
    swipeToSlide: true,
    focusOnSelect: false,
    slidesToShow: bundleSize ? Math.min(count, Object.keys(bundles).length + (isViewAllCardVisible ? 1 : 0)) : count
  };
  var settings_desktop = Object.assign(Object.assign({}, commonSetting), {
    arrows: true,
    slidesToScroll: Math.trunc(count),
    nextArrow: /*#__PURE__*/React.createElement(SliderArrow, {
      iconName: "arrowRight",
      size: 20
    }),
    prevArrow: /*#__PURE__*/React.createElement(SliderArrow, {
      iconName: "arrowLeft",
      size: 20
    })
  });
  var settings_mobile = Object.assign(Object.assign({}, commonSetting), {
    arrows: false,
    responsive: Object.keys(breakpointsMobile).map(function (size) {
      return {
        breakpoint: Number(size),
        settings: {
          slidesToShow: breakpointsMobile[size]
        }
      };
    }),
    variableWidth: source === 'homePageBundles'
  });
  var PanameraConstants = DependencyManager.getDependency('constants');
  var settings = Object.assign(Object.assign({}, PanameraConstants.platform === 'desktop' ? settings_desktop : settings_mobile), sliderSettings);
  var openModal = useCallback(function () {
    var locationUrl = getLocationUrl(location);
    var updatedUrl = "".concat(locationUrl);
    if (!locationUrl.includes(vasHash)) {
      updatedUrl = "".concat(locationUrl).concat(vasHash);
    }
    router === null || router === void 0 ? void 0 : router.push(updatedUrl);
  }, [location, router, vasHash]);
  var closeModal = useCallback(function () {
    var _a, _b;
    var locationUrl = getLocationUrl(location);
    if ((_b = (_a = location === null || location === void 0 ? void 0 : location.hash) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, vasHash)) {
      locationUrl = locationUrl.split('#')[0];
      router === null || router === void 0 ? void 0 : router.replace(locationUrl);
    }
  }, [location, router, vasHash]);
  useEffect(function () {
    getBundles(reqProps).then(function (res) {
      if (res && res.data && res.data.length && track) {
        var trackingInfo = Object.assign({
          result_count: res.data.length
        }, TrackingInfoManager.getTrackingInfo({
          browsing_location_id: locationId || UNKNOWN,
          browsing_mode: browsingMode,
          origin: origin,
          select_from: selectFrom
        }));
        track(HP_OLX_TRACKING.LISTINGS_RESULTS, trackingInfo);
      }
    });
  }, [reqProps, getBundles, track, locationId, origin, browsingMode, selectFrom]);
  if (!ItemCard || !EmptyCenter) {
    return null;
  }
  if (isError) {
    return /*#__PURE__*/React.createElement("div", {
      id: "bundleEmptyContainer"
    }, /*#__PURE__*/React.createElement(EmptyCenter, {
      title: EMPTY_BUNDLE.EMPTY_TITLE,
      subtitle: EMPTY_BUNDLE.EMPTY_SUB_TITLE,
      imageName: emptyCentreImageName,
      emptyClassName: classnames(css.empty, _defineProperty({}, css.buyEngager, source === 'buyEngager' || source === 'homePageBundles'))
    }));
  }
  var bundleItems = Object.keys(bundles).map(function (key) {
    return /*#__PURE__*/React.createElement("div", {
      key: "item_".concat(key)
    }, /*#__PURE__*/React.createElement(ItemCard, {
      item: bundles[key],
      enabledRealImpressions: true,
      visualizationType: visualizationType || 'smallGrid',
      tag: "div",
      listingType: "items",
      onVasTagTap: openModal,
      onView: onItemView,
      showOriginalTitle: showOriginalTitle,
      showSubTitle: showSubTitle,
      showSubDetails: showSubDetails,
      showFullPrice: showFullPrice,
      showOlxAutosAdCardTag: showOlxAutosAdCardTag,
      showMakeModel: showMakeModel,
      selectFrom: selectFrom,
      showEmiPlaceHolder: showEmiPlaceHolder,
      showVasStrip: showVasStrip,
      zrpWidgetType: zrpWidget ? widgetType : ''
    }));
  });
  var viewAllCarouseItem = isViewAllCardVisible ? (/*#__PURE__*/React.createElement("div", {
    onClick: clickHandler,
    className: css.showAllCard,
    "data-aut-id": "viewAllCard".concat(showVasStrip ? '' : 'WithoutVas')
  }, /*#__PURE__*/React.createElement("div", {
    key: "item_".concat(bundleSize),
    className: classNames(css.viewAllCarouselItem, _defineProperty({}, css.withoutVasStrip, !showVasStrip))
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 120,
    icon: "search",
    overrideClassName: css.searchIcon
  }), /*#__PURE__*/React.createElement(Button, {
    type: "secondaryBtn",
    className: css.viewAllBtn
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "showAll"
  }))))) : null;
  var tagCard = showTagInFirstCard && bundles && !!bundleSize ? ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleAnimation,
    root: cardContainerRef.current,
    threshold: THRESHOLDS,
    rootMargin: "-8px 0px 0px -78px",
    "data-aut-id": "tagObserver"
  }, /*#__PURE__*/React.createElement("div", {
    ref: firstCardRef,
    className: css.tagImgContainer
  })) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "cardContainer",
    className: classnames(css[PanameraConstants.platform], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, css.buyEngager, source === 'buyEngager' || source === 'homePageBundles'), css.bundleCard, source === 'bundleCard'), css.zrpWidget, zrpWidget === true), css.withArrows, settings.arrows && bundleSize + 1 > Math.ceil(count)), css.autoHeight, !isFetching && !!bundleSize), css.expandTrack, !!tagImage)),
    ref: cardContainerRef
  }, isFetching ? (/*#__PURE__*/React.createElement("div", {
    className: css.loaderContainer,
    "data-aut-id": "loader"
  }, _toConsumableArray(new Array(Math.trunc(count))).map(function (_, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, /*#__PURE__*/React.createElement(ShimmerCarouselCard, {
      showVasStrip: showVasStrip
    }));
  }))) : (/*#__PURE__*/React.createElement(React.Fragment, null, tagCard && tagImage && /*#__PURE__*/React.createElement("div", {
    ref: tagImageRef,
    "data-aut-id": "tagCard"
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    id: tagImage.alt,
    className: css.tagImage,
    image: tagImage
  })), /*#__PURE__*/React.createElement(Slider, Object.assign({
    ref: slider
  }, settings), [tagCard].concat(_toConsumableArray(bundleItems), [viewAllCarouseItem]))))), !hideShowAllLink && showAllUrl && !isFetching && !!bundleSize && bundleSize > count && (/*#__PURE__*/React.createElement("div", {
    className: classNames(css.showAllLink, [css[PanameraConstants.platform]])
  }, /*#__PURE__*/React.createElement(Button, {
    type: "tertiaryBtn",
    onClick: clickHandler
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "showAll"
  })))), VasSheetAsync && /*#__PURE__*/React.createElement(VasSheetAsync, {
    isOpened: !!((_b = (_a = location === null || location === void 0 ? void 0 : location.hash) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, vasHash)),
    onVasBottomSheetClose: closeModal,
    overlayClassName: css.overlay,
    showTitle: showOriginalTitle,
    showDisplayDetails: !showSubDetails,
    showYear: showYearInVasSheet,
    showOlxAutosAdCardTag: showOlxAutosAdCardTag
  }));
};
export var mapStateToProps = function mapStateToProps(state, ownProps) {
  var url = ownProps.url,
    apiParams = ownProps.apiParams,
    bundleType = ownProps.bundleType;
  var cookies = {
    onap: CookieManager.readCookie('onap') || CookieManager.readCookie('onap_dev') || ''
  };
  if (apiParams && !apiParams.min) {
    apiParams.min = 1;
  }
  var reqProps = {
    cookies: cookies,
    type: 'CXE_Bundles',
    url: url,
    apiParams: apiParams,
    bundleType: bundleType
  };
  return {
    bundles: bundlesSelector(state, reqProps, ownProps.config),
    isError: isError(state, reqProps),
    isFetching: isFetching(state, reqProps),
    reqProps: reqProps,
    browsingMode: state.track.browsingMode,
    origin: getTrackingOrigin(state, ownProps.location == null ? null : ownProps.location, ownProps.config)
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getBundles: function getBundles(reqProps) {
      return dispatch(_getBundles(reqProps));
    }
  };
};
export default compose(withComponentDependency, withRouter, withConfig, connect(mapStateToProps, mapDispatchToProps))(Bundle);